module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "sl-spinner",
    style: (_vm.spinnerStyle)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3185a3e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Spinner.vue
// module id = 15
// module chunks = 0